import Typography from '@mui/material/Typography';
//import { cancerstat, cancerstat_3 } from "../../../../../constants";

export default function StatisticsCancerText() {
  
  return (
<div>
    
<Typography variant="h6" >
    
Whole Genome Sequencing (WGS) was performed on the Oxford Nanopore Technologies (ONT) PromethION platform using long-read sequencing. 
<br /><br />
For this module, your genetic data was scanned against hereditary cancer risk panels curated by ClinGen, 
where thousands of researchers and clinicians have determined which genes are clinically relevant for evaluating cancer susceptibility.
<br /><br />
Variants were classified based on trusted databases such as ClinVar, ClinGen, and others, following established international guidelines to ensure medical relevance.
<br /><br />
Accuracy.<br /><br />
Sequencing technology is highly advanced and results are robust; however, no genetic test can predict disease with 100% certainty. Many factors — including lifestyle, environment, and personal history — also influence cancer development.
<br /><br />
Genetic findings should always be discussed with a healthcare professional or genetic counselor to determine the appropriate next steps.

</Typography>    
</div>

   )
}